export const CUSTOMER_API_URL = process.env.REACT_APP_CUSTOMER_API_URL;
export const FIREBASE_API_KEY = process.env.REACT_APP_FIREBASE_API_KEY;
export const FIREBASE_PROJECT_ID = process.env.REACT_APP_FIREBASE_PROJECT_ID;

export const PRODUCT_TAX = 1.08;
export const SUBSCRIPTION_NAME = 'ヒトツブカンロの定期便';